export default {
  methods: {
    getFastDFSToken(cb = () => {}) {
      return new Promise((resolve, reject) => {
        this.$http
          .get('/user-server/fds/get')
          .then(({ data: { code, value, message } }) => {
            if (code == 200) {
              if (typeof cb === 'function') {
                cb(value.accessToken, value.appId)
              }
              resolve({
                appToken: value.accessToken,
                appId: value.appId
              })
            } else {
              this.$message.error(message)
              reject('request fail')
            }
          })
          .catch(err => {
            console.log(err)
            reject('request error')
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixinDriver.js